import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Button,
  useDisclosure,
  Icon,
} from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { Plus } from 'lucide-react';
import { RegionForm } from './RegionForm';

export function RegionFormModal() {
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
      <Button size="sm" variant="solid" onClick={onOpen} leftIcon={<Icon as={Plus} />}>
        <Trans>Add new region</Trans>
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="xl" closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Trans>Add new region</Trans>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Box ml="auto">
              <RegionForm onClose={onClose} />
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
